import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";
import { AxiosResponse } from "axios";

export const toGetDashboard = createAsyncThunk("main/dashboard", async () => {
  try {
    const response = await CAxios.get(`${baseUrlApi}dashboard`);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toGetProjects = createAsyncThunk("main/projects", async () => {
  try {
    const response = await CAxios.get(`${baseUrlApi}projects`);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toGetInitiativesSummary = createAsyncThunk(
  "main/initiatives/summary",
  async () => {
    try {
      const response = await CAxios.get(`${baseUrlApi}initiatives/summary`);
      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const toGetInitiativesAnalytics = createAsyncThunk(
  "main/initiatives/analytics",
  async () => {
    try {
      const response = await CAxios.get(`${baseUrlApi}initiatives/analytics`);
      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const toGetProjectDetails = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("main/project/details", async (access_token) => {
  try {
    const response = await CAxios.get(`${baseUrlApi}projects/${access_token}`);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toGetInitiativeDetails = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("main/initiative/details", async (id) => {
  try {
    const response = await CAxios.get(`${baseUrlApi}initiatives/${id}/details`);
    return response;
  } catch (error) {
    throw error;
  }
});

// to add task note

export const toAddTaskNote = createAsyncThunk<AxiosResponse<any, any>, any>(
  "main/task/note",
  async (data) => {
    try {
      const response = await CAxios.post(`${baseUrlApi}task/note`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
);
//to add project note
export const toAddProjectNote = createAsyncThunk<AxiosResponse<any, any>, any>(
  "main/project/note",
  async (data) => {
    try {
      const response = await CAxios.post(`${baseUrlApi}project/note`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
);
export const toAddInitiativeNote = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("main/initiative/note", async (data) => {
  try {
    const response = await CAxios.post(`${baseUrlApi}initiative/note`, data);
    return response;
  } catch (error) {
    throw error;
  }
});
export const toGetProjectOpertaions = createAsyncThunk<AxiosResponse<any, any>, any>(
  "main/project/operations",
  async (data) => {
    try {
      const response = await CAxios.post(`${baseUrlApi}project/operations`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
);
export const toGetProjectOpertaionsStatus = createAsyncThunk<AxiosResponse<any, any>, any>(
  "main/project/operations/status",
  async (data) => {
    try {
      const response = await CAxios.post(`${baseUrlApi}project/operations/status`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
);
